import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import BriefingForm from "@/components/BriefingForm";
import AccessGate from "@/components/AccessGate";
import { BriefingProvider, useBriefing } from "@/context/BriefingContext";
import { AccessProvider, useAccess } from "@/context/AccessContext";

import Hero from "@/sections/Hero";
import Thesis from "@/sections/Thesis";
import WhyPharma from "@/sections/WhyPharma";
import Schematic from "@/sections/Schematic";
import DarkFactory from "@/sections/DarkFactory";
import WhyGigaOne from "@/sections/WhyGigaOne";
import StrategicImportance from "@/sections/StrategicImportance";
import NumericAnchors from "@/sections/NumericAnchors";
import ClosingCTA from "@/sections/ClosingCTA";

function Shell() {
  const { unlocked } = useAccess();
  const { openBriefing } = useBriefing();

  return (
    <main data-testid="home-root" className="relative">
      {/* Site content is always mounted so briefing modal can open from the gate */}
      <div
        aria-hidden={!unlocked}
        style={{
          visibility: unlocked ? "visible" : "hidden",
          // avoid flicker by keeping in DOM but hidden until unlocked
        }}
      >
        <Nav />
        <Hero />
        <Thesis />
        <WhyPharma />
        <Schematic />
        <DarkFactory />
        <WhyGigaOne />
        <StrategicImportance />
        <NumericAnchors />
        <ClosingCTA />
        <Footer />
      </div>

      <BriefingForm />
      <AccessGate onRequestBriefing={openBriefing} />
    </main>
  );
}

export default function Home() {
  return (
    <AccessProvider>
      <BriefingProvider>
        <Shell />
      </BriefingProvider>
    </AccessProvider>
  );
}
